import { navigate } from '@reach/router';

export default (target: string) => {
  navigate(target);
};
